<!--
 * @Description: 地图
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-06 13:37:52
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-06-28 18:08:44
 -->
<template>
  <div class="mapContent">
    <transition name="el-zoom-in-center">
      <div class="ChinaMap" v-if="mapType === 'China'">
        <dv-flyline-chart-enhanced :dev="true" :config="ChinaMapConfig" style="width:100%;height:100%;" />
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div class="HenanMap" v-if="mapType === 'Henan'">
        <dv-flyline-chart-enhanced :dev="true" :config="HenanMapConfig" style="width:100%;height:100%;" />
      </div>
    </transition>
    <!-- 全国地图、河南地图切换 -->
    <div class="mapTabs">
        <span
          :class="[`mapItem ${mapActive === index ? 'active' : ''}`]"
          v-for="(item, index) in mapTabs"
          :key="index"
          @click="selectMap(index)">{{item.label}}</span>
      </div>
    <!-- 现有产品数量 -->
    <div class="productStatics">
      <div class="content">
        现有产品数量 <span class="productNow">{{productStatics.total}}</span> &nbsp;&nbsp;&nbsp;已接入 <span class="connectedProduct">{{productStatics.joined}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mapContent',
  components: {
  },
  data () {
    return {
      mapType: 'Henan',
      productStatics: {},
      mapActive: 1,
      mapTabs: [
        {
          label: '全国',
          value: 'China',
        },
        {
          label: '河南',
          value: 'Henan',
        },
      ],
      HenanMapConfig: {},
      ChinaMapConfig: {},
    }
  },
  methods: {
    /**
     * @description                   地图切换
     * @param     {Number}          当前选择索引
     * @return {undefied}             无返回值
     */
    selectMap (index) {
      if (this.mapActive === index) {
        return
      }
      this.mapActive = index
      if (index === 0) {
        this.mapType = 'China'
      } else if (index === 1) {
        this.mapType = 'Henan'
      }
    },
    /**
     * @description                   获取河南省地图数据
     * @return {undefied}             无返回值
     */
    getHenanMapData () {
      this.$http.get('/rest/screen/project/list', {
        provinceId: 410000,
      })
        .then(res => {
          if (res.code === 0) {
            let points = [
              {
                name: '郑州市',
                coordinate: [0.52, 0.31],
                icon: {
                  src: '/static/img/layout/mapCenterPoint.png',
                  width: 30,
                  height: 30,
                },
                halo: {
                  show: true,
                },
                text: {
                  color: '#00ffee',
                },
              },
            ]
            let lines = []
            res.data.map(item => {
              if (item.cityPosition) {
                points.push({
                  name: item.cityName,
                  coordinate: [parseFloat(item.cityPosition.split(',')[0]), parseFloat(item.cityPosition.split(',')[1])],
                })
                lines.push({
                  radius: 60,
                  width: 2,
                  source: '郑州市',
                  target: item.cityName,
                })
              }
            })
            this.HenanMapConfig = {
              bgImgSrc: '/static/img/layout/map-henan.png',
              points: points,
              lines: lines,
              icon: {
                show: true,
                src: '/static/img/layout/mapPoint.png',
              },
              text: {
                show: true,
              },
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   获取全国地图数据
     * @return {undefied}             无返回值
     */
    getChinaMapData () {
      this.$http.get('/rest/screen/project/list')
        .then(res => {
          if (res.code === 0) {
            let points = [
              {
                name: '河南省',
                coordinate: [0.65, 0.45],
                icon: {
                  src: '/static/img/layout/mapCenterPoint.png',
                  width: 30,
                  height: 30,
                },
                halo: {
                  show: true,
                },
                text: {
                  color: '#00ffee',
                },
              },
            ]
            let lines = []
            res.data.map(item => {
              if (item.provincePosition) {
                points.push({
                  name: item.provinceName,
                  coordinate: [parseFloat(item.provincePosition.split(',')[0]), parseFloat(item.provincePosition.split(',')[1])],
                })
                lines.push({
                  radius: 60,
                  width: 2,
                  source: '河南省',
                  target: item.provinceName,
                })
              }
            })
            this.ChinaMapConfig = {
              bgImgSrc: '/static/img/layout/map-China.png',
              points: points,
              lines: lines,
              icon: {
                show: true,
                src: '/static/img/layout/mapPoint.png',
              },
              text: {
                show: true,
              },
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   获取产品数量数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/home/product/summary')
        .then(res => {
          if (res.code === 0) {
            this.productStatics = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getChinaMapData()
    this.getHenanMapData()
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .mapContent {
    width: 717px;
    height: 100%;
    position: relative;
    .productStatics {
      width: 284px;
      height: 52px;
      background: url('/static/img/layout/overviewProductBg.png');
      background-size: 100% 100%;
      color: #b6b6b6;
      font-size: 16px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .content {
        .productNow {
          font-size: 18px;
          font-weight: bold;
          color: #ffe400;
        }
        .connectedProduct {
          font-size: 18px;
          font-weight: bold;
          color: #15b9b7;
        }
      }
    }
    .HenanMap {
      width: 717px;
      height: 685px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .ChinaMap {
      width: 717px;
      height: 712px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .mapTabs {
        position: absolute;
        right: 0;
        top: 0;
        width: 90px;
        height: 26px;
        border: 1px solid #05dbe3;
        border-radius: 4px;
        .mapItem {
          text-align: center;
          font-size: 16px;
          color: #fff;
          width: 50%;
          height: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: space-around;
          cursor: pointer;
        }
        .active {
          background: #04b8bf;
        }
      }
  }
</style>
